// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as TrackingRouteImport } from './routes/tracking'
import { Route as RiskReductionRouteImport } from './routes/riskReduction'
import { Route as NoticeRouteImport } from './routes/notice'
import { Route as NewsRouteImport } from './routes/news'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InsureRouteImport } from './routes/insure'
import { Route as DocumentRouteImport } from './routes/document'
import { Route as BusinessDashboardRouteImport } from './routes/business-dashboard'
import { Route as AuthRedirectRouteImport } from './routes/authRedirect'
import { Route as AssistantRouteImport } from './routes/assistant'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ValuationReportMmsiRouteImport } from './routes/valuation-report/$mmsi'
import { Route as PlaybackIdRouteImport } from './routes/playback/$id'
import { Route as PiccFleetDashboardRouteImport } from './routes/picc/fleet-dashboard'
import { Route as PiccAuthRedirectRouteImport } from './routes/picc/auth-redirect'
import { Route as KbtMapAuthRedirectRouteImport } from './routes/kbt-map/auth-redirect'
import { Route as BillSearchRouteImport } from './routes/bill/search'
import { Route as InsureIndexRouteImport } from './routes/insure/index'
import { Route as InsureVesselFilterRouteImport } from './routes/insure/vessel-filter'
import { Route as InsureShipyardRecommendRouteImport } from './routes/insure/shipyard-recommend'
import { Route as InsureRecommendRouteImport } from './routes/insure/recommend'
import { Route as InsureRateCalculationRouteImport } from './routes/insure/rate-calculation'
import { Route as InsureEvaluationRouteImport } from './routes/insure/evaluation'
import { Route as AssistantIndexRouteImport } from './routes/assistant/index'
import { Route as AssistantSmartAppraisalRouteImport } from './routes/assistant/smart-appraisal'
import { Route as AssistantLawFirmSearchRouteImport } from './routes/assistant/law-firm-search'
import { Route as AssistantCaseSearchRouteImport } from './routes/assistant/case-search'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountRiskRouteImport } from './routes/account/risk'
import { Route as AccountManagementRouteImport } from './routes/account/management'
import { Route as AccountFavoritesRouteImport } from './routes/account/favorites'
import { Route as PiccCargoRedirectUrlRouteImport } from './routes/picc/cargo-redirect/$url'
import { Route as BillReportQueryIdRouteImport } from './routes/bill/report/$queryId'
import { Route as BillConfirmQueryIdRouteImport } from './routes/bill/confirm/$queryId'
import { Route as V6RiskReportMmsiRouteImport } from './routes/v6/risk/report/$mmsi'
import { Route as V5RiskReportMmsiRouteImport } from './routes/v5/risk/report/$mmsi'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
            id: '/unauthorized',path: '/unauthorized',getParentRoute: () => rootRouteImport
          })
const TrackingRoute = TrackingRouteImport.update({
            id: '/tracking',path: '/tracking',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/tracking.lazy').then((d) => d.Route))
const RiskReductionRoute = RiskReductionRouteImport.update({
            id: '/riskReduction',path: '/riskReduction',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/riskReduction.lazy').then((d) => d.Route))
const NoticeRoute = NoticeRouteImport.update({
            id: '/notice',path: '/notice',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/notice.lazy').then((d) => d.Route))
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/news.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const InsureRoute = InsureRouteImport.update({
            id: '/insure',path: '/insure',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/insure.lazy').then((d) => d.Route))
const DocumentRoute = DocumentRouteImport.update({
            id: '/document',path: '/document',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/document.lazy').then((d) => d.Route))
const BusinessDashboardRoute = BusinessDashboardRouteImport.update({
            id: '/business-dashboard',path: '/business-dashboard',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/business-dashboard.lazy').then((d) => d.Route))
const AuthRedirectRoute = AuthRedirectRouteImport.update({
            id: '/authRedirect',path: '/authRedirect',getParentRoute: () => rootRouteImport
          })
const AssistantRoute = AssistantRouteImport.update({
            id: '/assistant',path: '/assistant',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/assistant.lazy').then((d) => d.Route))
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/account.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ValuationReportMmsiRoute = ValuationReportMmsiRouteImport.update({
            id: '/valuation-report/$mmsi',path: '/valuation-report/$mmsi',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/valuation-report/$mmsi.lazy').then((d) => d.Route))
const PlaybackIdRoute = PlaybackIdRouteImport.update({
            id: '/playback/$id',path: '/playback/$id',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/playback/$id.lazy').then((d) => d.Route))
const PiccFleetDashboardRoute = PiccFleetDashboardRouteImport.update({
            id: '/picc/fleet-dashboard',path: '/picc/fleet-dashboard',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/picc/fleet-dashboard.lazy').then((d) => d.Route))
const PiccAuthRedirectRoute = PiccAuthRedirectRouteImport.update({
            id: '/picc/auth-redirect',path: '/picc/auth-redirect',getParentRoute: () => rootRouteImport
          })
const KbtMapAuthRedirectRoute = KbtMapAuthRedirectRouteImport.update({
            id: '/kbt-map/auth-redirect',path: '/kbt-map/auth-redirect',getParentRoute: () => rootRouteImport
          })
const BillSearchRoute = BillSearchRouteImport.update({
            id: '/bill/search',path: '/bill/search',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/bill/search.lazy').then((d) => d.Route))
const InsureIndexRoute = InsureIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => InsureRoute
          })
const InsureVesselFilterRoute = InsureVesselFilterRouteImport.update({
            id: '/vessel-filter',path: '/vessel-filter',getParentRoute: () => InsureRoute
          }).lazy(() => import('./routes/insure/vessel-filter.lazy').then((d) => d.Route))
const InsureShipyardRecommendRoute = InsureShipyardRecommendRouteImport.update({
            id: '/shipyard-recommend',path: '/shipyard-recommend',getParentRoute: () => InsureRoute
          }).lazy(() => import('./routes/insure/shipyard-recommend.lazy').then((d) => d.Route))
const InsureRecommendRoute = InsureRecommendRouteImport.update({
            id: '/recommend',path: '/recommend',getParentRoute: () => InsureRoute
          }).lazy(() => import('./routes/insure/recommend.lazy').then((d) => d.Route))
const InsureRateCalculationRoute = InsureRateCalculationRouteImport.update({
            id: '/rate-calculation',path: '/rate-calculation',getParentRoute: () => InsureRoute
          }).lazy(() => import('./routes/insure/rate-calculation.lazy').then((d) => d.Route))
const InsureEvaluationRoute = InsureEvaluationRouteImport.update({
            id: '/evaluation',path: '/evaluation',getParentRoute: () => InsureRoute
          }).lazy(() => import('./routes/insure/evaluation.lazy').then((d) => d.Route))
const AssistantIndexRoute = AssistantIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AssistantRoute
          })
const AssistantSmartAppraisalRoute = AssistantSmartAppraisalRouteImport.update({
            id: '/smart-appraisal',path: '/smart-appraisal',getParentRoute: () => AssistantRoute
          }).lazy(() => import('./routes/assistant/smart-appraisal.lazy').then((d) => d.Route))
const AssistantLawFirmSearchRoute = AssistantLawFirmSearchRouteImport.update({
            id: '/law-firm-search',path: '/law-firm-search',getParentRoute: () => AssistantRoute
          }).lazy(() => import('./routes/assistant/law-firm-search.lazy').then((d) => d.Route))
const AssistantCaseSearchRoute = AssistantCaseSearchRouteImport.update({
            id: '/case-search',path: '/case-search',getParentRoute: () => AssistantRoute
          }).lazy(() => import('./routes/assistant/case-search.lazy').then((d) => d.Route))
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account/index.lazy').then((d) => d.Route))
const AccountRiskRoute = AccountRiskRouteImport.update({
            id: '/risk',path: '/risk',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account/risk.lazy').then((d) => d.Route))
const AccountManagementRoute = AccountManagementRouteImport.update({
            id: '/management',path: '/management',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account/management.lazy').then((d) => d.Route))
const AccountFavoritesRoute = AccountFavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account/favorites.lazy').then((d) => d.Route))
const PiccCargoRedirectUrlRoute = PiccCargoRedirectUrlRouteImport.update({
            id: '/picc/cargo-redirect/$url',path: '/picc/cargo-redirect/$url',getParentRoute: () => rootRouteImport
          })
const BillReportQueryIdRoute = BillReportQueryIdRouteImport.update({
            id: '/bill/report/$queryId',path: '/bill/report/$queryId',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/bill/report/$queryId.lazy').then((d) => d.Route))
const BillConfirmQueryIdRoute = BillConfirmQueryIdRouteImport.update({
            id: '/bill/confirm/$queryId',path: '/bill/confirm/$queryId',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/bill/confirm/$queryId.lazy').then((d) => d.Route))
const V6RiskReportMmsiRoute = V6RiskReportMmsiRouteImport.update({
            id: '/v6/risk/report/$mmsi',path: '/v6/risk/report/$mmsi',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/v6/risk/report/$mmsi.lazy').then((d) => d.Route))
const V5RiskReportMmsiRoute = V5RiskReportMmsiRouteImport.update({
            id: '/v5/risk/report/$mmsi',path: '/v5/risk/report/$mmsi',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/v5/risk/report/$mmsi.lazy').then((d) => d.Route))





const AccountRouteChildren = {
  AccountFavoritesRoute: AccountFavoritesRoute,AccountManagementRoute: AccountManagementRoute,AccountRiskRoute: AccountRiskRoute,AccountIndexRoute: AccountIndexRoute
}

const AccountRouteWithChildren = AccountRoute._addFileChildren(AccountRouteChildren)




const AssistantRouteChildren = {
  AssistantCaseSearchRoute: AssistantCaseSearchRoute,AssistantLawFirmSearchRoute: AssistantLawFirmSearchRoute,AssistantSmartAppraisalRoute: AssistantSmartAppraisalRoute,AssistantIndexRoute: AssistantIndexRoute
}

const AssistantRouteWithChildren = AssistantRoute._addFileChildren(AssistantRouteChildren)




const InsureRouteChildren = {
  InsureEvaluationRoute: InsureEvaluationRoute,InsureRateCalculationRoute: InsureRateCalculationRoute,InsureRecommendRoute: InsureRecommendRoute,InsureShipyardRecommendRoute: InsureShipyardRecommendRoute,InsureVesselFilterRoute: InsureVesselFilterRoute,InsureIndexRoute: InsureIndexRoute
}

const InsureRouteWithChildren = InsureRoute._addFileChildren(InsureRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRouteWithChildren,AssistantRoute: AssistantRouteWithChildren,AuthRedirectRoute: AuthRedirectRoute,BusinessDashboardRoute: BusinessDashboardRoute,DocumentRoute: DocumentRoute,InsureRoute: InsureRouteWithChildren,LoginRoute: LoginRoute,NewsRoute: NewsRoute,NoticeRoute: NoticeRoute,RiskReductionRoute: RiskReductionRoute,TrackingRoute: TrackingRoute,UnauthorizedRoute: UnauthorizedRoute,BillSearchRoute: BillSearchRoute,KbtMapAuthRedirectRoute: KbtMapAuthRedirectRoute,PiccAuthRedirectRoute: PiccAuthRedirectRoute,PiccFleetDashboardRoute: PiccFleetDashboardRoute,PlaybackIdRoute: PlaybackIdRoute,ValuationReportMmsiRoute: ValuationReportMmsiRoute,BillConfirmQueryIdRoute: BillConfirmQueryIdRoute,BillReportQueryIdRoute: BillReportQueryIdRoute,PiccCargoRedirectUrlRoute: PiccCargoRedirectUrlRoute,V5RiskReportMmsiRoute: V5RiskReportMmsiRoute,V6RiskReportMmsiRoute: V6RiskReportMmsiRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)